export default __webpack_public_path__ + "static/media/onboarding.a4f1cf4c.mp4";